module.exports = __webpack_public_path__ + "static/media/stofferingen-46.e8887a1a.jpg";